<script setup lang="ts">
import { computed, defineComponent, h } from 'vue'
import { useRouter } from 'vue-router'
import { PopupBasicHeader } from 'wepin-vue-component'
import SelectReceiveAccount from './SelectReceiveAccount.vue'
import { SelectAccount } from '@/components'
import { useI18nTypes } from '@/composables'
import { useWalletStore } from '@/stores'
import type { BaseAccount, Promisable, Account } from '@/types'

const emits = defineEmits<{
  (event: 'close'): void
  (event: 'select-account', account: BaseAccount): void
}>()

const { t } = useI18nTypes()
const router = useRouter()

const walletId = computed(() => {
  return router.currentRoute.value.params.walletId as string
})
const excludeTokens = computed(() => {
  return router.currentRoute.value.query.excludeTokens === 'true'
})

const walletStore = useWalletStore()
const accountList = computed(() => {
  return (
    (walletStore.walletList?.find((wallet) => wallet.id === walletId.value)
      ?.accounts as unknown as Account[]) ?? []
  )
})
const onExit = () => {
  emits('close')
}

const onSelectAccount = (account: BaseAccount) => {
  emits('select-account', account)
}
</script>
<script lang="ts">
export const createSelectReceiveAccount = (
  onSelectAccount: (account: BaseAccount) => Promisable<void>,
) => {
  return defineComponent<typeof SelectReceiveAccount>((props) => {
    return () =>
      h(SelectReceiveAccount, {
        'onSelect-account': (account: BaseAccount) => {
          onSelectAccount(account)
        },
        ...props,
      })
  })
}
</script>

<template>
  <div>
    <PopupBasicHeader :title="t('receive.title')" :exit="onExit" />
    <SelectAccount
      :account-list="accountList"
      :header-text="t('receive.select_account')"
      :exclude-tokens="excludeTokens"
      @select-account="onSelectAccount"
    />
  </div>
</template>

<style scoped></style>
